import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export type RetailIndividual = {
  percentage: string;
};

type RetailIndividualsTableProps = {
  values: RetailIndividual[];
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

const RetailIndividualsTable = ({
  values,
  setFieldValue,
}: RetailIndividualsTableProps) => {
  const handleAddRow = () => {
    const newRows = [...values, { percentage: "" }];
    setFieldValue("retailIndividuals", newRows);
  };

  const handleChangeRow = (index: number, value: string) => {
    const newRows = values.map((row, idx) =>
      idx === index ? { percentage: value } : row
    );
    setFieldValue("retailIndividuals", newRows);
  };

  const handleRemoveRow = (index: number) => {
    const newRows = values.filter((_, idx) => idx !== index);
    setFieldValue("retailIndividuals", newRows);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead
            sx={{
              backgroundColor: "lightgreen",
              "& .MuiTableCell-root": { fontWeight: "bold", color: "black" },
            }}
          >
            <TableRow>
              <TableCell>Individual</TableCell>
              <TableCell align="right">%</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {values.map((row, index) => (
              <TableRow key={index}>
                <TableCell align="right">
                  <TextField
                    fullWidth
                    placeholder="%"
                    value={row.percentage}
                    onChange={(e) => handleChangeRow(index, e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleRemoveRow(index)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button variant="outlined" onClick={handleAddRow} sx={{ mt: 2 }}>
        Add Row
      </Button>
    </>
  );
};

export default RetailIndividualsTable;
